import { render, staticRenderFns } from "./sharedentity.vue?vue&type=template&id=9c0f1278"
import script from "./sharedentity.vue?vue&type=script&lang=js"
export * from "./sharedentity.vue?vue&type=script&lang=js"
import style0 from "./sharedentity.vue?vue&type=style&index=0&id=9c0f1278&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports